<div class="kt-portlet container">
	<div class="kt-portlet__head">
		<div class="encabezado mt-3">
			<h1 class="titulo"><i class="fas fa-tablet-rugged"></i>&nbsp;{{titulo}}</h1>
		</div>
	</div>
	<div class="kt-portlet__body">
		<form [formGroup]="dispositivoForm">
			<div class="row">
				<div class="col-md-4 form-group">
					<i class="fas fa-barcode-scan"></i>&nbsp;
					<label for="imei">IMEI</label>
					<input id="imei" type="text" class="form-control" formControlName="IMEI"
						[matAutocomplete]="autoImei" [readonly]="readonly" required>
					<mat-autocomplete #autoImei="matAutocomplete">
						<mat-option *ngFor="let imei of filteredImeis | async" [value]="imei">
							{{imei}}
						</mat-option>
					</mat-autocomplete>
					<span class="text-danger"
						*ngIf="(dispositivoForm.get('IMEI').touched) && dispositivoForm.get('IMEI').errors?.required">
						Campo requerido
					</span>
				</div>
				<div class="col-md-4 form-group">
					<i class="fas fa-barcode"></i>&nbsp;
					<label for="numeroSerie">Número de Serie</label>
					<input formControlName="NumeroSerie" class="form-control" id="numeroSerie">
					<span class="text-danger"
						*ngIf="(dispositivoForm.get('NumeroSerie').touched) && dispositivoForm.get('NumeroSerie').errors?.required">
						Campo requerido
					</span>
				</div>
				<div class="col-md-4 form-group">
					<i class="fas fa-th-list"></i>&nbsp;
					<label for="marca">Marca</label>
					<select id="marca" formControlName="IdMarca" class="form-control"
						(change)="obtenerModelo(idMarca.value)" #idMarca>
						<option *ngFor="let marca of marcasDispositivo" [value]="marca.id">{{marca.nombre}}</option>
					</select>
					<span class="text-danger"
						*ngIf="(dispositivoForm.get('IdMarca').touched) && dispositivoForm.get('IdMarca').errors?.required">
						Campo requerido
					</span>
				</div>
				<div class="col-md-4 form-group">
					<i class="fas fa-list"></i>&nbsp;
					<label for="modelo">Modelo</label>
					<select id="modelo" formControlName="IdModelo" class="form-control">
						<option *ngFor="let modelo of modeloDispositivo" [value]="modelo.id">{{modelo.nombre}}</option>
					</select>
					<span class="text-danger"
						*ngIf="(dispositivoForm.get('IdModelo').touched) && dispositivoForm.get('IdModelo').errors?.required">
						Campo requerido
					</span>
				</div>
				<div class="col-md-4 form-group">
					<i class="fas fa-sim-card"></i>&nbsp;
					<label for="sim">Sim</label>
					<input id="sim" type="text" class="form-control" [formControl]="simControl"
						[matAutocomplete]="autoSim" required>
					<mat-autocomplete #autoSim="matAutocomplete" (optionSelected)='asignarSim($event.option.value)'>
						<mat-option *ngFor="let simOption of filteredSims | async" [value]="simOption.numeroTelefonico">
							{{simOption.numeroTelefonico}}
						</mat-option>
					</mat-autocomplete>
					<span class="text-danger"
						*ngIf="(simControl.touched) && dispositivoForm.get('IdSim').errors?.required">
						Campo requerido
					</span>
				</div>
				<div class="col-md-4 form-group">
					<i class="fas fa-user"></i>&nbsp;
					<label for="cliente">Cliente</label>
					<select id="cliente" formControlName="IdCliente" class="form-control">
						<option *ngFor="let cliente of clientesRegistros" [value]="cliente.id">{{cliente.nombre}}
						</option>
					</select>
					<span class="text-danger"
						*ngIf="(dispositivoForm.get('IdCliente').touched) && dispositivoForm.get('IdCliente').errors?.required">
						Campo requerido
					</span>
				</div>

			</div>
		</form>
		<mat-divider></mat-divider>
		<div class="kt-portlet__foot">
			<div class="kt-form__actions kt-form__actions">
				<button id="guardarBoton" mat-raised-button class="mt-3  btn btn-success" (click)="onSubmit()"
					[disabled]="dispositivoForm.invalid || loading"
					[ngClass]="{'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading}"
					style="margin-right: 15px;"><i class="fa fa-check"></i>&nbsp;Guardar</button>&nbsp;
				<button mat-raised-button (click)="onCancel()"><i class="fas fa-times"></i>&nbsp;Cancelar</button>
			</div>
		</div>
	</div>
</div>
